/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */

const canRole = (roles, role) => roles.includes(role);

export default function access(initialState) {
  const rolesRealm =
    initialState?.userInfo?.resource_access?.["realm-management"]?.roles;
  return {
    canRealmAdmin: canRole(rolesRealm || [], "realm-admin")
  };
}
